module.exports = __webpack_public_path__ + "img/logorclk.4edefc90.png";